import {
  ArrowRight,
  Compass,
  Handshake,
  MessageCircle,
} from "lucide-react";

import { MarketingButton } from "./ui/MarketingButton";
import { MarketingContainer } from "./ui/MarketingContainer";

const benefits = [
  {
    icon: Handshake,
    title: "Personal Onboarding",
    description:
      "Work directly with the MinistryIQ team to configure your church and import your existing data.",
  },
  {
    icon: MessageCircle,
    title: "Direct Support",
    description:
      "Receive hands-on support as your team begins using attendance, care, and reporting workflows.",
  },
  {
    icon: Compass,
    title: "Influence the Roadmap",
    description:
      "Share feedback and help shape the features MinistryIQ builds for churches next.",
  },
];

export function PilotProgramSection() {
  return (
    <section
      id="pricing"
      className="py-24"
    >
      <MarketingContainer>
        <div className="overflow-hidden rounded-[2rem] border border-indigo-400/20 bg-gradient-to-br from-indigo-500/15 via-slate-900 to-slate-950 p-8 sm:p-12 lg:p-16">
          <div className="mx-auto max-w-4xl text-center">
            <p className="text-sm font-semibold uppercase tracking-[0.2em] text-indigo-300">
              Pilot Program
            </p>

            <h2 className="mt-4 text-4xl font-black tracking-tight text-white sm:text-5xl">
              Now onboarding a limited number of pilot churches.
            </h2>

            <p className="mx-auto mt-6 max-w-3xl text-lg leading-8 text-slate-300">
              Get full access to MinistryIQ, guided onboarding,
              and direct support while helping shape the future
              of the platform.
            </p>
          </div>

          <div className="mt-14 grid gap-6 md:grid-cols-3">
            {benefits.map((benefit) => {
              const Icon = benefit.icon;

              return (
                <div
                  key={benefit.title}
                  className="rounded-2xl border border-white/10 bg-slate-950/50 p-6"
                >
                  <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-indigo-400/15 text-indigo-200">
                    <Icon className="h-6 w-6" />
                  </div>

                  <h3 className="mt-6 text-xl font-bold text-white">
                    {benefit.title}
                  </h3>

                  <p className="mt-3 leading-7 text-slate-400">
                    {benefit.description}
                  </p>
                </div>
              );
            })}
          </div>

          <div className="mt-14 flex flex-col items-center justify-between gap-6 rounded-2xl border border-white/10 bg-white/[0.04] p-6 sm:flex-row sm:p-8">
            <div className="text-center sm:text-left">
              <p className="text-sm font-semibold uppercase tracking-[0.16em] text-indigo-300">
                Pilot Pricing
              </p>

              <div className="mt-2 flex items-end justify-center gap-3 sm:justify-start">
                <span className="text-5xl font-black text-white">
                  $0
                </span>

                <span className="pb-1 text-slate-400">
                  during the pilot
                </span>
              </div>
            </div>

            <MarketingButton
              href="/request-access"
              className="w-full sm:w-auto"
            >
              Request Pilot Access
              <ArrowRight className="ml-2 h-4 w-4" />
            </MarketingButton>
          </div>
        </div>
      </MarketingContainer>
    </section>
  );
}
